var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPear0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.333333 714.666667a298.666667 245.333333 0 1 0 597.333334 0 298.666667 245.333333 0 1 0-597.333334 0Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.666667 725.333333c0-170.666667-128-213.333333-149.333334-341.333333-13.568-81.344-66.858667-149.333333-149.333333-149.333333s-135.765333 67.989333-149.333333 149.333333c-21.333333 128-149.333333 170.666667-149.333334 341.333333",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 106.666667s-64 64-64 170.666666",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 277.333333m-21.333333 0a21.333333 21.333333 0 1 0 42.666666 0 21.333333 21.333333 0 1 0-42.666666 0Z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 299.413333S485.333333 32 213.333333 128c29.333333 278.229333 298.666667 171.413333 298.666667 171.413333z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.909333 672.384C782.954667 544.170667 680.256 497.557333 661.333333 384c-10.965333-65.792-47.936-122.794667-105.301333-142.208C602.453333 272.32 618.666667 395.050667 618.666667 469.333333c0 85.333333 85.333333 128 85.333333 213.333334s-85.333333 192-213.333333 192c-236.949333 0-272.832-146.133333-276.885334-167.872-0.085333 2.624-0.448 5.205333-0.448 7.872 0 1.557333 0.256 3.093333 0.298667 4.629333-0.042667 2.069333-0.298667 3.925333-0.298667 6.037333h0.64c6.848 130.496 137.429333 234.666667 298.026667 234.666667s291.157333-104.170667 298.026667-234.666667H810.666667c0-2.112-0.256-3.968-0.298667-6.037333 0.042667-1.536 0.298667-3.072 0.298667-4.629333 0-14.464-1.813333-28.544-4.757334-42.282667z",
    fill: "#FFAB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 682.666667m-21.333333 0a21.333333 21.333333 0 1 0 42.666666 0 21.333333 21.333333 0 1 0-42.666666 0Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.666667 682.666667m-21.333334 0a21.333333 21.333333 0 1 0 42.666667 0 21.333333 21.333333 0 1 0-42.666667 0Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.333333 746.666667m-21.333333 0a21.333333 21.333333 0 1 0 42.666667 0 21.333333 21.333333 0 1 0-42.666667 0Z",
    fill: "#FF9100"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPear0);
export default __webpack_public_path__ + "static/media/Pear_0.e9a1a687195916b358a01abd92c0cc8f.svg";
export { ForwardRef as ReactComponent };